export const SUPPORTED_LANGUAGES = ['en', 'fr'];
export const LOGIN_LOCAL_STORAGE_LANGUAGE_KEY = 'sss:landing:login:language';
